import React from "react";
import { GitCompareArrows, Star } from "lucide-react";
import { SectionFrame } from "./SectionFrame";
import { StatusBadge } from "../../StatusBadge";

/** Monthly Record - Reconciliation section (spec item 4, non-optional): Published
 * Schedule -> Actual Attendance -> Difference. Every status/qualifying-premium value is
 * read from timecard_service's own classification and payroll_service's own stored
 * shift_premium_review_flags/payroll_line - never a second independent calculation. */
export const ReconciliationSection = ({ data, loading, error, onRetry }) => {
  const days = data?.days || [];
  return (
    <SectionFrame
      title="Reconciliation" icon={GitCompareArrows} testId="monthly-reconciliation-section"
      loading={loading} error={error} onRetry={onRetry}
      isEmpty={days.length === 0}
      emptyMessage="No published schedule or attendance record exists for this period yet."
    >
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-slate-50 text-slate-500 text-left">
            <tr>
              <th className="px-3 py-2 font-medium">Date</th>
              <th className="px-3 py-2 font-medium">Scheduled</th>
              <th className="px-3 py-2 font-medium">Actual</th>
              <th className="px-3 py-2 font-medium">Status</th>
              <th className="px-3 py-2 font-medium">Qualifying premium</th>
            </tr>
          </thead>
          <tbody>
            {days.map((d) => (
              <tr key={d.date} className="border-t border-slate-100" data-testid={`monthly-reconciliation-row-${d.date}`}>
                <td className="px-3 py-2 font-medium text-slate-700">{d.date}</td>
                <td className="px-3 py-2 text-slate-600">{d.scheduled_start ? `${d.scheduled_start}–${d.scheduled_end}` : "-"}</td>
                <td className="px-3 py-2 text-slate-600">{d.actual_clock_in ? `${d.actual_clock_in}–${d.actual_clock_out || "?"}` : "-"}</td>
                <td className="px-3 py-2"><StatusBadge status={d.status} /></td>
                <td className="px-3 py-2">
                  {d.is_qualifying_shift ? (
                    <span className="flex items-center gap-1 text-xs" data-testid={`monthly-reconciliation-premium-${d.date}`}>
                      <Star size={12} className="text-amber-500" /> <StatusBadge status={d.qualifying_shift_premium_status} />
                    </span>
                  ) : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SectionFrame>
  );
};
